<template>
    <div class="module-header-container">
        <div class="d-flex">
            <h5 class="flex-grow-1 module-header-title">{{title}}</h5>
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ModuleHeader",

        props: {
            title: {
                type: String,
                required: true
            }
        }
    }
</script>

<style scoped lang="scss">

    @import '~styles/colors';
    @import '~styles/util';

    .module-header-container {
        padding: 1.2rem 0;
        margin-bottom: 0;
        padding: 1rem;
        background-color: #7e8d9a; //#474d56; //#74808A; //$color-section-bg;
        border-bottom: 1px solid $color-section-border;
        margin-bottom: 1rem;
    }

    .module-header-title {
        color: $text-color-bright; //$text-gray;
        font-weight: 300;
        margin: 0;
        padding: 0;
    }

    a {
        @include text-exposed;
        color: $text-color-bright;
        padding: 0.5rem 1.3rem;
        background-color: $color-green;
        border-radius: 4px;
        font-size: 0.8rem;

        &:hover {
            color: $text-color-bright;
            text-decoration: none;
            background-color: darken($color-green, 10%);
        }
    }
</style>